import React from 'react';
import { SearchPanel } from '../../../../../components';
import { TABLE_CONFIG } from '../constants';

type SourcePaginationProps = {
  totalItems?: number;
  page?: number;
  onPageChange: (page: number) => void;
};

export const SourcePagination: React.FC<SourcePaginationProps> = ({
  totalItems,
  page,
  onPageChange,
}) => {
  return (
    <div className="mt-sm flex justify-between items-center">
      <SearchPanel
        totalItems={totalItems}
        page={page}
        perPage={TABLE_CONFIG.PER_PAGE}
        withPaginate
        setPage={onPageChange}
      />
    </div>
  );
};
